import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatasourcesIconColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5 14.1667H8.33334C8.33334 16.4292 8.33334 18.5942 8.33334 20.8333H27.5C28.3333 20.8333 28.3333 21.2758 28.3333 21.6667V27.5H35V21.6667C35 16.2025 30.3992 14.1667 27.5 14.1667Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 10H9.16667V25H5V10Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 5H21.6667V7.5H20V5ZM18.3333 11.6667H23.3333V22.5H18.3333V11.6667Z",
			fill: "#1565C0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 6.66666C30 6.20583 29.6275 5.83333 29.1667 5.83333L22.5 7.49999H19.1667L12.5 5.83333C12.04 5.83333 11.6667 6.20583 11.6667 6.66666V11.6667H30V6.66666Z",
			fill: "#FFC107"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1667 9.16667L22.5 6.66667H19.1667L17.5 9.16667V12.5H24.1667V9.16667Z",
			fill: "#FF9800"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.6667 35C30.2667 35 29.1667 33.9692 29.1667 32.6558C29.1667 31.5308 30.8675 28.7667 31.2158 28.2042L31.6667 27.5L32.1167 28.205C32.4658 28.7675 34.1667 31.5783 34.1667 32.6567C34.1667 33.9692 33.0667 35 31.6667 35Z",
			fill: "#81D4FA"
		})
	]
});
export default SvgDatasourcesIconColor;
